import styled from "styled-components";
import { BRAND_DARK } from "@streeteasy/design-system/colors";
import Button from "@streeteasy/design-system/deprecated/Button";
import colors from "@streeteasy/design-system/deprecated/colors";
import Text from "@streeteasy/design-system/deprecated/Text";

import { smallScreen } from "src/shared/constants/screenSizes";

export const ValuationContainer = styled.div``;

export const ValuationText = styled(Text).attrs({
  type: "sm"
})`
  line-height: 26px;

  @media screen and (max-width: ${smallScreen}px) {
    font-size: 16px;
  }
`;

export const Spacer = styled.hr`
  background-color: ${colors.rabbitGrey};
  margin-bottom: 0;
`;

export const InquiryTrigger = styled(Button).attrs({
  height: "low",
  minWidth: true,
  theme: "white"
})`
  margin-top: 10px;

  @media screen and (max-width: ${smallScreen}px) {
    height: 40px;
  }
`;

export const InquiryPrompt = styled(ValuationText)`
  margin-top: 5px;
`;

export const ValuationFaq = styled.div`
  display: inline;
  margin-left: 10px;
`;

export const ValuationFaqLink = styled.a`
  color: ${BRAND_DARK};
  text-decoration: underline;
`;
